<template>
  <div>
    <nav-bar/>
    <transition-page>
      <router-view id="m-app"></router-view>
    </transition-page>
    <footer-bar v-if="showFooter"></footer-bar>
  </div>
</template>

<script>
import NavBar from './components/NavBar'
import FooterBar from './components/FooterBar'
import TransitionPage from '@/components/TransitionPage'

export default {
  components: {
    TransitionPage,
    NavBar,
    FooterBar
  },
  computed: {
    showFooter () {
      return this.$route.path === '/m' || this.$route.path === '/m/my'
    }
  }
}
</script>

<style lang="scss" scoped>
#m-app{
  padding-top: env(safe-area-inset-top);
  padding-right: env(safe-area-inset-right);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
}
</style>
